import ManagedBar from "components/ManagedBar";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router";
import { registerroutes as routes } from "navigation/registerroutes";
import "./style.scss";
import LoaderOverlay from "components/LoaderOverlay";
import SideLogo from "./SideLogo";
import registerSideMenu from "./Register/registerSideMenu";

type Props = {
};

const RegisterPage: React.FC<Props> = ({ }: Props) => {
	const { user, userCore } = useSelector(
		(state: any) => state.authReducer
	)

	const [loading, setLoading] = useState<boolean>(false);

	return (
		<Switch>
			{routes.map((route: any) => {
				const { component:Component, props, wrapperClass,step,...rest } = route;
				return (
					<Route {...rest} render={(routeProps) => {
						return (
							<div className={`auth-wrapper auth-wrapper__lavender kyc-wrapper${wrapperClass?' '+wrapperClass:''}`}>
								<ManagedBar userCore={userCore} />
								<div className="kyc-wrapper__wrap-white">
									<SideLogo steps={registerSideMenu} step={step} />
									<Component {...props} {...routeProps} loading={loading} setLoading={setLoading} />
									{loading && <LoaderOverlay/> }
								</div>
							</div>
						);
					}} />

				);

			})}
		</Switch>
	);
};

export default RegisterPage;